import { useContext } from 'react';
import { AdapterContext } from '../Context';

export default function useAdapter() {
  const adapter = useContext(AdapterContext);

  return adapter;
}
